gsap.registerPlugin(ScrollTrigger, CSSRulePlugin);
ScrollTrigger.refresh();
let mm = gsap.matchMedia();

var rule = CSSRulePlugin.getRule(".subscription-section:not(.design_mode) .banner-img::before");
ScrollTrigger.create({
    animation: gsap.to(rule, {
        duration: 1,
        left: "100%",
        ease: "none",
    }),
    trigger: '.subscription-section .banner-img',
    start: "top 80%",
    end: "bottom center"
});

var animTwo = CSSRulePlugin.getRule(".template-index .target-anim:not(.design_mode)::before");
ScrollTrigger.create({
    animation: gsap.to(animTwo, {
        duration: 0.8,
        height: "0%"
    }),
    trigger: '.target-anim',
    start: "top 80%",
    end: "bottom center",
    // markers: true,
});

var animThree = CSSRulePlugin.getRule("body.template-index .global-half-banner:not(.design_mode) .info::before");
ScrollTrigger.create({
    animation: gsap.to(animThree, {
        duration: 0.8,
        width: "0%",
        stagger: 0.8,
    }),
    trigger: '.global-half-banner .info',
    start: "top 80%",
    end: "bottom center",
    // markers: true,
});

mm.add("(min-width: 768px)", () => {
    let parallexImage = document.querySelector(".split-banner .banner__media img");
    let parallexTl = gsap.timeline({
        scrollTrigger: {
            trigger: parallexImage,
            scrub: true,
            pin: false,
            start: "top 80%",
            end: "bottom 20%",
        },
    });
    parallexTl.from(parallexImage, {
        yPercent: -15,
        ease: "none",
    }).to(parallexImage, {
        yPercent: 15,
        ease: "none",
    });
});
mm.add("(max-width: 991px)", () => {
    const mytl = gsap.timeline()
        .to('.swiper-slide .slide-animation', {
            duration: .8,
            delay: 0.3,
            width: 0,
            ease: "none"
        });
});
mm.add("(min-width: 992px)", () => {
    const mytl = gsap.timeline()
        .to('.swiper-slide .slide-animation', {
            duration: 1.5,
            delay: 0.3,
            width: 0,
            ease: "none"
        });
        // window.addEventListener("load", (event) => {
        //     mytl.play();
        // });
});

